import React, { useState } from "react";
import { utils } from "../../../utils/utils";
import SequencesTable from "./SequencesTable";
import { useAuth } from "../../../providers/authProvider";
import { Container, Button } from "reactstrap";
import InformationModal from "../../InformationModal";
import ConfirmationModal from "../../ConfirmationModal";
import SequenceDetailsModal from "./SequenceDetailsModal";
import { sequenceApi } from "../../../services/sequenceServices";

const CHECKING_IN_PROGRESS_STATUS = 5;
const WAITING_FOR_SCRUBBING_STATUS = 8;
const CHECKING_IN_PROGRESS_TAB = "CHECKING_IN_PROGRESS_TAB";

const CheckingInProgress = ({
  sequencesTotal,
  setSequencesTotal,
  reloadTabs,
  setReloadTabs,
  tabName,
  search = "",
}) => {
  const [authContext] = useAuth();
  const userId = authContext?.currentUser?.id;
  const [detailModal, setDetailModal] = useState(false);
  const [checkerId, setCheckerId] = useState();
  const [detailerId, setDetailerId] = useState();
  const [sequenceStatusId, setSequenceStatusId] = useState();
  const [sequenceSelected, setSequenceSelected] = useState();
  const [informationModal, setInformationModal] = useState(
    utils.initInformationModal
  );
  const [confirmationModal, setConfirmationModal] = useState(
    utils.initConfirmationModal
  );

  const columns = [
    {
      accessor: "sendToScrubbingButton",
      Header: "",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 135,
      Cell: (rowData) => {
        const sequence = rowData.row.original;
        const canPerform =
          utils.canUserPerformDetailingAction(
            sequence,
            CHECKING_IN_PROGRESS_STATUS,
            userId
          ) || utils.isAdminRole(authContext.currentUser?.role?.id);
        if (!canPerform) return null;
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"success"}
            onClick={() => {
              const sequence = rowData.row.original;
              changeSequenceStatus(
                sequence,
                WAITING_FOR_SCRUBBING_STATUS,
                sequence?.detailer?.id ?? null,
                sequence?.checker?.id ?? null
              );
            }}
          >
            Send to Scrubbing
          </Button>
        );
      },
    },
    {
      accessor: "seeJobDetailsButton",
      Header: "",
      headerProps: { className: "text-truncate" },
      disableSortBy: true,
      width: 130,
      Cell: (rowData) => {
        return (
          <Button
            className="btn-sm rounded px-1 py-0"
            color={"primary"}
            onClick={() => {
              const sequence = rowData.row.original;
              setSequenceSelected(sequence);
              setDetailerId(sequence?.detailer?.id || null);
              setCheckerId(sequence?.checker?.id || null);
              setSequenceStatusId(sequence?.sequenceStatusId);
              setDetailModal(true);
            }}
          >
            See Job Details
          </Button>
        );
      },
    },
  ];

  const changeSequenceStatus = async (
    sequence,
    sequenceStatusId,
    effectiveDetailerId = detailerId,
    effectiveCheckerId = checkerId
  ) => {
    try {
      let statusName;
      if (sequenceStatusId === WAITING_FOR_SCRUBBING_STATUS) {
        statusName = "Scrubbing";
      } else {
        statusName = "Review";
      }

      setConfirmationModal({
        isOpen: true,
        onSubmit: async () => {
          try {
            setReloadTabs([]);
            const { detailer, checker, ...sequenceFields } = sequence;
            await sequenceApi.updateSequence(sequence.id, {
              ...sequenceFields,
              detailerId: effectiveDetailerId,
              checkerId: effectiveCheckerId,
              sequenceStatusId,
            });
            setConfirmationModal(utils.initConfirmationModal);
            setInformationModal({
              isOpen: true,
              title: `Send to ${statusName}`,
              body: `Sequence ${
                detailModal ? "updated" : `sent to ${statusName}`
              } successfully.`,
            });
            setReloadTabs([
              CHECKING_IN_PROGRESS_TAB,
              utils.detailingTabs[sequenceStatusId],
            ]);
          } catch (error) {
            onClear();
            setInformationModal({
              isOpen: true,
              title: "Error",
              body: "There was an error with your request.",
            });
          }
        },
        onClose: onClear,
        title: `Send to ${statusName}`,
        body: `<div class="text-center">
          ${
            detailModal
              ? "Do you confirm you want to update the sequence " +
                sequenceSelected?.job?.jobNumber
              : sequenceStatusId === WAITING_FOR_SCRUBBING_STATUS
              ? "Are you sure you are ready to send this job for Scrubbing"
              : "Are you sure you are ready to send this job to the Detailing Manager for Review"
          }?
        </div>`,
      });
    } catch (error) {
      onClear();
      setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  };

  const onClear = async () => {
    setDetailerId();
    setCheckerId();
    setConfirmationModal(utils.initConfirmationModal);
    setInformationModal(utils.initInformationModal);
    setSequenceStatusId();
    setSequenceSelected();
    setDetailModal(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    changeSequenceStatus(sequenceSelected, sequenceStatusId);
  };

  return (
    <Container fluid className="px-0">
      <SequencesTable
        columns={columns}
        sequenceStatusId={CHECKING_IN_PROGRESS_STATUS}
        setSequencesTotal={setSequencesTotal}
        sequencesTotal={sequencesTotal}
        reloadTabs={reloadTabs}
        tabName={tabName}
        search={search}
      />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          onClose={() => onClear()}
        />
      ) : confirmationModal.isOpen ? (
        <ConfirmationModal {...confirmationModal} />
      ) : (
        <SequenceDetailsModal
          sequence={sequenceSelected}
          detailModal={detailModal}
          onSubmit={onSubmit}
          onClear={onClear}
          checkerId={checkerId}
          setCheckerId={setCheckerId}
          detailerId={detailerId}
          setDetailerId={setDetailerId}
          enableUpdate={
            utils.canUserPerformDetailingAction(
              sequenceSelected,
              sequenceStatusId,
              userId
            ) || utils.isAdminRole(authContext.currentUser?.role?.id)
          }
          setInformationModal={setInformationModal}
          statusId={sequenceStatusId}
          setStatusId={setSequenceStatusId}
        />
      )}
    </Container>
  );
};

export default CheckingInProgress;
